import { CommonAPIService } from 'src/servicehandlers/CommonHandler';

export class AircraftAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  get(router) {
    const url = '/api/aircraft';
    return this.CommonAPIService.getCall(url, null, router);
  }

  getById(id, router) {
    const url = `/api/aircraft/${id}`;
    return this.CommonAPIService.getCall(url, null, router);
  }

  create(formData) {
    const url = '/api/aircraft';
    return this.CommonAPIService.newFileCall(url, formData);
  }
  delete(id, router) {
    const url = `/api/aircraft/${id}`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }

  update(id, formData) {
    const url = `/api/aircraft/${id}`;
    return this.CommonAPIService.newFileCall(url, formData);
  }

  getAircraftTypes(router) {
    const url = '/api/aircraft/types';
    return this.CommonAPIService.getCall(url, null, router);
  }

}
export default AircraftAPIService;
